import React from "react";
import { withRouter } from "react-router-dom";
import DetailUserService from "./detailUserService";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import { BsFillHouseDoorFill } from "react-icons/bs";
import moment from "moment";
import NumberFormat from "react-number-format";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import detailCss from "../../../css/detailSanzione/detailSanzione.css";
import Menucustom from "../../../common/menu/menucustom";
import { Modal, Button, Row, Col, Form, ListGroup, InputGroup } from "react-bootstrap";
import IDuser from "../../../common/mookup/iduser";
import { validEmail, validPassword } from "../../../common/utils";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";

toast.configure();
class DetailUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plafond:0,
      showModalDisattivaLicenza: false,
      indexDaEliminare: 0,
      isErrorPassword: false,
      enableSalvaModifice: true,
      showModalStoricoRotoli: false,
      showModalResetPasswordUtente: false,
      testoModifica: "Abilità Modifiche",
      salvaUtenteModal: false,
      selectRoleOption: false,
      showPassword:false,
      showConfermaPassword:false,
      disableInput: true,
      loading: false,
      showModalAssegnaRotolino: false,
      arrayListaRotoliniUtente: [],
      arrayListaLicenzeUtente: [],
      password: "",
      confermaPassword: "",
      buttonResetPassword: true,
      EliminaUserModal: false,
      newRotolino: {
        codiceRotolino: "",
        dataDiEmissione: "",
      },
      userControllore: {
        idAnagraficaOperatore: "",
        numMatricola: "",
        nome: "",
        cognome: "",
        codiceFiscale: "",
        email: "",
        telefono: "",
        password: "",
        ruoliOperatori: {
          idAnagraficaRuoloOperatore: "",
          nomeRuolo: "",
        },
      },
      loadingButton:false,
    };
    // this.backHome = this.backHome.bind(this);
  }

  componentDidMount() {
    this.detailSanzioneService = new DetailUserService();
    var userControllore = JSON.parse(sessionStorage.getItem("userControllore"));

    var importoIncasso = JSON.parse(sessionStorage.getItem("Imp_importo_incasso_max"));
    this.setState({plafond:importoIncasso})

    // console.log(userControllore);
    this.detailSanzioneService.getDetailUtente(
      userControllore.idAnagraficaOperatore,
      this.onSuccessGetDetailUser.bind(this)
    );
    // this.detailSanzioneService.getListUtenteLicenza(
    //   userControllore.idAnagraficaOperatore,
    //   this.onSuccessGetDataUserControllore.bind(this)
    // );
    this.detailSanzioneService.getListUtenteRotolini(
      userControllore.idAnagraficaOperatore,
      this.onSuccessGetDataListaRotoliniUtente.bind(this)
    );
    this.detailSanzioneService.getListUtenteLicenza(
      userControllore.idAnagraficaOperatore,
      this.onSuccessGetDataListaLicenzaUtente.bind(this)
    );
  }

  onSuccessGetDetailUser(result) {
    // console.log(result);
    this.setState({ userControllore: result });
  }

  onSuccessGetDataListaLicenzaUtente(result) {
    this.setState({ arrayListaLicenzeUtente: result });
  }

  onSuccessGetDataListaRotoliniUtente(result) {
    // console.log(result);
    this.setState({ arrayListaRotoliniUtente: result });
    // console.log(this.state.userControllore);
  }

  //Nuovo rotolino
  changeTextNewIdRotolino(event) {
    this.state.newRotolino.codiceRotolino = event.target.value;
    this.setState({ newRotolino: this.state.newRotolino });
  }

  //Nuovo rotolino
  changeTextNewDataAsegnazione(event) {
    this.state.newRotolino.dataDiEmissione = event.target.value;
    this.setState({ newRotolino: this.state.newRotolino });
  }

  //idendificazione controllore
  changeTextUserId_Anagrfica(event) {
    this.state.userControllore.idAnagraficaOperatore = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  changeTextNum_matricola(event) {
    this.state.userControllore.numMatricola = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  changeTextEmail(event) {
    this.state.userControllore.email = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  //idendificazione controllore

  //anagrafica controllore
  changeTextNome(event) {
    this.state.userControllore.nome = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  changeTextCognome(event) {
    this.state.userControllore.cognome = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  changeTextTelefono(event) {
    this.state.userControllore.telefono = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  changeTextCF(event) {
    this.state.userControllore.codiceFiscale = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  changeTextEmail(event){
    this.state.userControllore.email = event.target.value;
    this.setState({userControllore:this.state.userControllore});
  }
  changeTextPassword(event) {
    // console.log(event.target.value);
    if (!validPassword.test(this.state.password)) {
      this.setState({ isErrorPassword: true });
    } else {
      this.setState({ isErrorPassword: false });
    }
    this.state.password = event.target.value;
    this.setState({ state: this.state.password });
  }
  changeTextRuolo(event) {
    this.state.userControllore.ruoliOperatori.nomeRuolo = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
    this.state.userControllore.ruoliOperatori.idAnagraficaRuoloOperatore =
      parseInt(event.target.value);
  }
  changeTextPlafond(event) {
    this.state.plafond = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  //anagrafica controllore

  //materiale operativo
  changeTextIdRotolo(event) {
    // console.log("event chiave " + event.target.id);
    // console.log("event.target.value valore " + event.target.value);
    // console.log(event.target.id + " " + event.target.value);
    this.state.userControllore.listRotolini[event.target.id] =
      event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  changeTextDataAsse(event) {
    // console.log(event.target.id + " " + event.target.value);
    this.state.userControllore.listRotolini[event.target.id] =
      event.target.value;

    this.setState({ userControllore: this.state.userControllore });
  }
  //materiale operativo

  //Licenza
  changeTextIdLicenza(event) {
    // console.log(event.target.id + " " + event.target.value);
    this.state.userControllore.licenza[event.target.id] = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  changeTextDataAttivazione(event) {
    // console.log(event.target.id + " " + event.target.value);
    this.state.userControllore.licenza[event.target.id] = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  changeTextIdDevace(event) {
    // console.log(event.target.id + " " + event.target.value);
    this.state.userControllore.licenza[event.target.id] = event.target.value;
    this.setState({ userControllore: this.state.userControllore });
  }
  //Licenza

  disabilitaLicenza(event) {
    this.setState({
      showModalDisattivaLicenza: true,
      indexDaEliminare: event.target.id,
    });
  }

  anagraficaControllore() {
    return (
      <div className="container-fluid">
        <br />
        <br />
        <div className="d-sm-flex align-items-center justify-content-between mb-6">
          <h1 className="h1 mb-2 text-gray-800">
            Dettaglio Utente<br></br>
            <small style={{ fontSize: "14px" }} className="mb-2 text-gray-800">
              Impostazioni &#8594;{" "}
              <a
                onClick={() => {
                  window.location.href = "#/manageProfile";
                }}
              >
                <u>Utenti</u>{" "}
              </a>{" "}
              &#8594; Dettaglio Utente
            </small>
          </h1>
        </div>
        <div className="col">
          <div className="row">
            <div className="col-sm-4">
              <div className="row">
                <br></br>
                <div className="col-sm-12">
                  <b> ID Utente:</b>{" "}
                  {this.state.userControllore.idAnagraficaOperatore}
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-12">
                  <b> Numero matricola: </b>
                  {this.state.userControllore.numMatricola}
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-12">
                  <b> E-mail:</b> {this.state.userControllore.email}
                </div>
              </div>
              <br></br>
            </div>
            <div className="col-sm-2"></div>
          </div>
          {this.formDatiControllore()}
        </div>
        <br></br>
        {this.bottoni()}
        <br></br>
      </div>
    );
  }

  sectionInput(event) {
    // console.log(event.target.value);
  }
  removeOption(event) {
    this.setState((prevState) => ({
      selectRoleOption: false,
    }));
  }

  AnnulaResetPasswordUtnete() {
    this.setState({
      showModalResetPasswordUtente: false,
      password: "",
      confermaPassword:"",
      isErrorPassword: false,
      buttonResetPassword:true,
    });
  }

  confermaResetPasswordUtente(event) {
    this.setState({ isErrorPassword: false });
    if (!validPassword.test(this.state.password)) {
      this.setState({ isErrorPassword: true });
      toast.warn("Password non valida", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      this.setState({ isErrorPassword: false });
      // console.log(this.state.password);
    }

    if (this.state.isErrorPassword === false) {
      this.setState({ loadingButton:true})
      this.detailSanzioneService.resetPassword(
        this.state.userControllore.idAnagraficaOperatore,
        this.state.password,
        (result) => {
          if (result.status === 200) {
            toast.success("Reset Password", {
              position: toast.POSITION.TOP_RIGHT,
            });
            this.setState({
              loadingButton: false,
              showModalResetPasswordUtente: false,
              password: "",
              confermaPassword:"",
              buttonResetPassword:true,
            });
          } else {
            toast.error("Qualcosa è andato storto", {
              position: toast.POSITION.TOP_RIGHT,
            });
            this.setState({
              loadingButton:false,
              showModalResetPasswordUtente: false,
              password: "",
              confermaPassword:"",
              buttonResetPassword:true,
            });
          }
        }
      );
    }
  }
  onChangeConfermaPassword(event) {
    this.state.confermaPassword = event.target.value;
    this.setState({ state: this.state }, () => {
      if (this.state.confermaPassword === this.state.password) {
        this.setState({ buttonResetPassword: false });
      } else {
        this.setState({ buttonResetPassword: true });
      }
    });
  }

  modalResetPasswordUtente() {
    return (
      <>
        <Modal size="xl" show={this.state.showModalResetPasswordUtente}>
          <Modal.Header>
            <Modal.Title>Reset Password Utente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              <legend className="w-auto" style={{ color: "#4e73df" }}>
                {/*w-auto */}
                <div className="col">Nuova Password</div>
              </legend>
              <br></br>
              <div className="row">
                <div className="col-sm-4">Password</div>
                <div className="col-sm-8">
                <InputGroup>

<input
  className="form-control"
  type={this.state.showPassword? "text":"password"}
  value={this.state.password}
  onChange={this.changeTextPassword.bind(this)}
  disabled={this.state.disableInput}
></input>
<Button onClick={()=>this.setState({showPassword:!this.state.showPassword})}>
{this.state.showPassword ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-eye-slash-fill"
          viewBox="0 0 16 16"
        >
          <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
          <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-eye-fill"
          viewBox="0 0 16 16"
        >
          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
        </svg>
      )}
</Button>
</InputGroup>
{this.state.isErrorPassword ? (
  <small className="text-danger">
    <ul style={{ fontSize: "10px" }}>
      <li>
        La password deve essere più lunga di 8 caratteri
      </li>
      <li>
        La password deve contenere almeno un carattere
        speciale
      </li>
      <li>La password deve contenere almeno una maiuscola</li>
      <li>La password deve contenere almeno una minuscola</li>
      <li>La password deve contenere un numero</li>
    </ul>
  </small>
) : (
  ""
)}
</div>
</div>
<br></br>
<div className="row">
<div className="col-sm-4">Conferma Password</div>
<div className="col-sm-8">
<InputGroup>
  <input
    className="form-control"
    type={this.state.showConfermaPassword? "text":"password"}
    value={this.state.confermaPassword}
    onChange={this.onChangeConfermaPassword.bind(this)}
    disabled={this.state.disableInput}
  ></input>
  <Button onClick={()=>this.setState({showConfermaPassword:!this.state.showConfermaPassword})}>
  {this.state.showConfermaPassword ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-eye-slash-fill"
          viewBox="0 0 16 16"
        >
          <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
          <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-eye-fill"
          viewBox="0 0 16 16"
        >
          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
        </svg>
      )}
  </Button>
</InputGroup>
                </div>
              </div>
              <br></br>
            </>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnulaResetPasswordUtnete.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              disabled={this.state.buttonResetPassword}
              onClick={this.confermaResetPasswordUtente.bind(this)}
            >
              {this.state.loadingButton ? <LoadSpinner/> : "Conferma modifica"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  AnnulaDiabilitaLicenza() {
    this.setState({ showModalDisattivaLicenza: false });
  }

  confermaDiabilitaLicenza(event) {
    // console.log(this.state.userControllore.idAnagraficaOperatore);
    // this.idUser = decoded.IDUSER;
    // console.log(this.state.indexDaEliminare);

    this.licenza = {
      idDevice:
        this.state.arrayListaLicenzeUtente[this.state.indexDaEliminare]
          .idDevice,
      dataDiAttivazione:
        this.state.arrayListaLicenzeUtente[this.state.indexDaEliminare]
          .dataDiAttivazione,
      id: this.state.arrayListaLicenzeUtente[this.state.indexDaEliminare].id,
    };
    var ID = event.target.index;

    // console.log(
    //   this.state.arrayListaLicenzeUtente[this.state.indexDaEliminare]
    // );

    this.detailSanzioneService.deleteLicenza(
      this.state.userControllore.idAnagraficaOperatore,
      this.licenza,
      (result) => {
        if (result.status === 200) {
          toast.success("licenza disabilitata");
          window.location.reload();
        } else {
          toast.error("licenza non disabilitata");
        }
      }
    );
    // this.detailSanzioneService.getListUtenteLicenza(
    //   this.state.userControllore.idAnagraficaOperatore,
    //  (result)=>{
    //   this.setState({ arrayListaLicenzeUtente: result ,showModalDisattivaLicenza: false });
    //  }
    // );

    this.setState({ showModalDisattivaLicenza: false });
  }

  modalDisabilitaLicenzaUtente() {
    return (
      <>
        <Modal  show={this.state.showModalDisattivaLicenza}>
          <Modal.Body>
            <Modal.Title>
              Confermi di voler disabilitare la licenza ?
            </Modal.Title>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnulaDiabilitaLicenza.bind(this)}
            >
              Annulla
            </Button>
            <Button
              id={this.state.indexDaEliminare}
              variant="primary"
              onClick={this.confermaDiabilitaLicenza.bind(this)}
            >
              Conferma modifica
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  showModalRotolino() {
    this.setState({ showModalAssegnaRotolino: true });
  }
  annullaModalRotolino() {
    this.state.newRotolino.codiceRotolino = "";
    this.state.newRotolino.dataDiEmissione = "";
    this.setState({ showModalAssegnaRotolino: false });
  }

  salvaNewRotolino() {
    // this.state.newRotolino.map((Data) => {
    //   Data.dataDiEmissione = new Date(Data.dataDiEmissione).set
    // })
    this.dataEmissioneInserita =
      new Date(this.state.newRotolino.dataDiEmissione).getFullYear() +
      "/" +
      new Date(this.state.newRotolino.dataDiEmissione).getMonth() +
      "/" +
      new Date(this.state.newRotolino.dataDiEmissione).getDay();

    this.orarioAssegnazioneOre = new Date().getHours();
    this.orarioAssegnazioneMinuti = new Date().getMinutes();

    this.oreMinutiRotolino = new Date(this.dataEmissioneInserita).setHours(
      this.orarioAssegnazioneOre,
      this.orarioAssegnazioneMinuti,
      0,
      0
    );

    // console.log(this.dataOreMinutiAssegnazione);
    // this.state.newRotolino.dataDiEmissione = new Date(this.oreMinutiRotolino).toJSON();
    this.state.newRotolino.dataDiEmissione = this.oreMinutiRotolino;
    // this.state.newRotolino.dataDiEmissione = new Date(this.state.newRotolino.dataDiEmissione)
    // console.log(this.state.newRotolino.dataDiEmissione);
    var userControllore = JSON.parse(sessionStorage.getItem("userControllore"));
    this.detailSanzioneService.saveRotolino(
      userControllore.idAnagraficaOperatore,
      this.state.newRotolino,
      (result) => {
        // console.log(result.status);

        if (result.status === 200) {
          toast.success("Rotolino Assegnato", {
            position: toast.POSITION.TOP_RIGHT,
          });
          this.detailSanzioneService.getListUtenteRotolini(
            userControllore.idAnagraficaOperatore,
            this.onSuccessGetDataListaRotoliniUtente.bind(this)
          );
        } else {
          toast.success("Rotolino Non Assegnato", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }
    );
    // console.log(this.state.newRotolino);
    this.state.newRotolino.codiceRotolino = "";
    this.state.newRotolino.dataDiEmissione = "";
    this.setState({ showModalAssegnaRotolino: false });
  }

  showModalAssegnaRotolino() {
    return (
      <>
        <Modal size="lg" show={this.state.showModalAssegnaRotolino}>
          <Modal.Title>Assegnazione rotolino</Modal.Title>
          <Modal.Body>
            <div className="row">
              <div className="col">
                <label className="">Id rotolo</label>
                <input
                  className="form-control"
                  type="text"
                  value={this.state.newRotolino.codiceRotolino}
                  onChange={this.changeTextNewIdRotolino.bind(this)}
                ></input>
              </div>
              <div className="col">
                <label className="">Data Assegnazione</label>
                <input
                  className="form-control"
                  type="date"
                  value={this.state.newRotolino.dataDiEmissione}
                  onChange={this.changeTextNewDataAsegnazione.bind(this)}
                ></input>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaModalRotolino.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              onClick={this.salvaNewRotolino.bind(this)}
            >
              Conferma modifica
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  formDatiControllore() {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    return (
      <fieldset className="border p-2">
        <legend className="" style={{ color: "#4e73df" }}>
          {/*w-auto */}
          <div className="row">
            <div className="col">Anagrafica Utente</div>
            <div className="col">{this.bottoneModificaUser(this)}</div>
            {decoded.RUOLO === "4" ? (
              <div className="col">{this.bottoneEliminaUser(this)}</div>
            ) : (
              ""
            )}
          </div>
        </legend>

        <br></br>
        <br></br>
        <div className="row">
          <div className="col-sm-4">Nome</div>
          <div className="col-sm-8">
            <input
              className="form-control"
              type="text"
              value={this.state.userControllore.nome}
              onChange={this.changeTextNome.bind(this)}
              disabled={this.state.disableInput}
            ></input>
          </div>
        </div>
        <br></br>
        <div className="row">
          <div className="col-sm-4">Cognome</div>
          <div className="col-sm-8">
            <input
              className="form-control"
              type="text"
              value={this.state.userControllore.cognome}
              onChange={this.changeTextCognome.bind(this)}
              disabled={this.state.disableInput}
            ></input>
          </div>
        </div>
        <br></br>
        <div className="row">
          <div className="col-sm-4">Email</div>
          <div className="col-sm-8">
            <input
              className="form-control"
              type="text"
              value={this.state.userControllore.email}
              onChange={this.changeTextEmail.bind(this)}
              disabled={this.state.disableInput}
            ></input>
          </div>
        </div>
        <br></br>
        <div className="row">
          <div className="col-sm-4">Telefono</div>
          <div className="col-sm-8">
            <input
              className="form-control"
              type="tel"
              value={this.state.userControllore.telefono}
              onChange={this.changeTextTelefono.bind(this)}
              disabled={this.state.disableInput}
            ></input>
          </div>
        </div>
        <br></br>
        <div className="row">
          <div className="col-sm-4">Ruolo</div>
          <div className="col-sm-8">
            <div className="select-container">
              <select
                onChange={this.changeTextRuolo.bind(this)}
                className="form-select"
                disabled={this.state.disableInput}
              >
                <option
                  selected
                  value={
                    this.state.userControllore.ruoliOperatori
                      .idAnagraficaRuoloOperatore === 1
                      ? "operatore"
                      : this.state.userControllore.ruoliOperatori
                          .idAnagraficaRuoloOperatore === 2
                      ? "operatore avanzato"
                      : this.state.userControllore.ruoliOperatori
                          .idAnagraficaRuoloOperatore === 4
                      ? "Admin"
                      : "verificatore"
                  }
                  className={`${this.state.selectRoleOption ? "" : "d-none"}`}
                >
                  {this.state.userControllore.ruoliOperatori
                    .idAnagraficaRuoloOperatore === 1
                    ? "operatore"
                    : this.state.userControllore.ruoliOperatori
                        .idAnagraficaRuoloOperatore === 2
                    ? "operatore avanzato"
                    : this.state.userControllore.ruoliOperatori
                        .idAnagraficaRuoloOperatore === 4
                    ? "Admin"
                    : "verificatore"}
                </option>
                <option value={0}>Verificatore</option>
                <option value={2}>Operatore avanzato</option>
                <option value={4}>Admin</option>
              </select>
            </div>
          </div>
        </div>
        <br></br>
        <div className="row">
          <div className="col-sm-4">Plafond</div>
          <div className="col-sm-8">
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text">€</span>
              </div>
              <input
                className="form-control"
                type="number"
                value={this.state.plafond}
                onChange={this.changeTextPlafond.bind(this)}
                disabled={true}
              ></input>
            </div>
          </div>
        </div>
        <br></br>
        <fieldset className="border p-2">
          <legend className="w-auto" style={{ color: "#4e73df" }}>
            Materiale Operativo
          </legend>
          {this.state.arrayListaRotoliniUtente.map((listRotolini, index) => {
            //   console.log(index + " " + listRotolini.codiceRotolino);

            const giornoCorretta =
              new Date(listRotolini.dataDiEmissione).getDate() < 10
                ? "0" + new Date(listRotolini.dataDiEmissione).getDate()
                : new Date(listRotolini.dataDiEmissione).getDate();
            const meseCorretto =
              new Date(listRotolini.dataDiEmissione).getMonth() + 1 < 10
                ? "0" + (new Date(listRotolini.dataDiEmissione).getMonth() + 1)
                : new Date(listRotolini.dataDiEmissione).getMonth() + 1;
            const annoCorretto = new Date(
              listRotolini.dataDiEmissione
            ).getFullYear();

            const ore =
              new Date(listRotolini.dataDiEmissione).getHours() < 10
                ? "0" + new Date(listRotolini.dataDiEmissione).getHours()
                : new Date(listRotolini.dataDiEmissione).getHours();

            const minuti =
              new Date(listRotolini.dataDiEmissione).getMinutes() < 10
                ? "0" + new Date(listRotolini.dataDiEmissione).getMinutes()
                : new Date(listRotolini.dataDiEmissione).getMinutes();

            this.dataTime =
              giornoCorretta +
              "/" +
              meseCorretto +
              "/" +
              annoCorretto +
              " " +
              ore +
              ":" +
              minuti;

            // this.dataTime =
            //   new Date(listRotolini.dataDiEmissione).getDate() +
            //   "/" +
            //   new Date(listRotolini.dataDiEmissione).getMonth() +
            //   "/" +
            //   new Date(listRotolini.dataDiEmissione).getFullYear() +
            //   " " +
            //   new Date(listRotolini.dataDiEmissione).getHours() +
            //   ":" +
            //   new Date(listRotolini.dataDiEmissione).getMinutes();
            return (
              <>
                {index >= 4 ? (
                  <></>
                ) : (
                  <>
                    <div className="row">
                      <div className="col-sm-2">Id rotolo</div>
                      <div className="col-sm-3">
                        <input
                          className="form-control"
                          type="text"
                          id={index}
                          value={listRotolini.codiceRotolino}
                          onChange={this.changeTextIdRotolo.bind(this)}
                          disabled={true}
                        ></input>
                      </div>
                      <div className="col-sm-2">Data Assegnazione</div>
                      <div className="col-sm-5">
                        <input
                          className="form-control"
                          type="text"
                          id={index}
                          value={this.dataTime}
                          onChange={this.changeTextDataAsse.bind(this)}
                          disabled={true}
                        ></input>
                      </div>
                    </div>
                    <br></br>
                  </>
                )}
              </>
            );
          })}
          <div className="row">
            <div className="col d-flex justify-content-center">
              <button
                type="button"
                onClick={this.showStoricoRotolini.bind(this)}
                className="btn btn-primary"
              >
                Storico Rotolini
              </button>
            </div>
            <div className="col d-flex justify-content-center"></div>
            <div className="col d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.showModalRotolino.bind(this)}
              >
                Assegna Rotolino
              </button>
            </div>
          </div>
          <br></br>
        </fieldset>
        <fieldset className="border p-2">
          <legend className="w-auto" style={{ color: "#4e73df" }}>
            Licenza
          </legend>
          <table className="table table-bordered text-center">
            {/* <div className="col-sm-2">Id Licenza</div>
                  <div className="col-sm-3">
                    <input
                      className="form-control"
                      type="text"
                      value={licenza.idDevice}
                      id={index}
                      onChange={this.changeTextIdLicenza.bind(this)}
                      disabled={this.state.disableInput}
                    ></input>
                  </div> */}

            <thead>
              <tr>
                <th scope="col">Id Licenza</th>
                <th scope="col">Data Attivazione</th>
                <th scope="col">Azioni</th>
              </tr>
            </thead>
            <tbody>
              {this.state.arrayListaLicenzeUtente.map((licenza, index) => {
                this.giorniCorrettiAttivazione =
                  new Date(licenza.dataDiAttivazione).getDate() < 10
                    ? "0" + new Date(licenza.dataDiAttivazione).getDate()
                    : new Date(licenza.dataDiAttivazione).getDate();

                this.mesiCorrettiAttivazione =
                  new Date(licenza.dataDiAttivazione).getMonth() + 1 < 10
                    ? "0" + (new Date(licenza.dataDiAttivazione).getMonth() + 1)
                    : new Date(licenza.dataDiAttivazione).getMonth() + 1;

                this.oreAtt =
                  new Date(licenza.dataDiAttivazione).getHours() < 9
                    ? "0" + new Date(licenza.dataDiAttivazione).getHours()
                    : new Date(licenza.dataDiAttivazione).getHours();

                this.minutiAtt =
                  new Date(licenza.dataDiAttivazione).getMinutes() < 9
                    ? "0" + new Date(licenza.dataDiAttivazione).getMinutes()
                    : new Date(licenza.dataDiAttivazione).getMinutes();

                var dataAttivazioneLicenza =
                  this.giorniCorrettiAttivazione +
                  "/" +
                  this.mesiCorrettiAttivazione +
                  "/" +
                  new Date(licenza.dataDiAttivazione).getFullYear() +
                  " " +
                  this.oreAtt +
                  ":" +
                  this.minutiAtt;
                return (
                  <>
                    <tr>
                      <td>
                        <input
                          className="form-control"
                          type="text"
                          value={licenza.idDevice}
                          id={index}
                          onChange={this.changeTextIdDevace.bind(this)}
                          disabled={true}
                        ></input>
                      </td>
                      <td>
                        <input
                          className="form-control"
                          type="text"
                          value={dataAttivazioneLicenza}
                          id={index}
                          onChange={this.changeTextDataAttivazione.bind(this)}
                          disabled={true}
                        ></input>
                      </td>
                      <td>
                        <button
                          className="btn btn-danger"
                          disabled={this.state.disableInput}
                          id={index}
                          onClick={this.disabilitaLicenza.bind(this)}
                        >
                          <i className="fas fa-fw fa-trash"></i>{" "}
                        </button>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>

            {/* <div className="col-sm-2">Id Device</div>
<div className="col-sm-2">
  <input
    className="form-control"
    type="text"
    value={licenza.idDevice}
    id={index}
    onChange={this.changeTextIdDevace.bind(this)}
    disabled={true}
  ></input>
</div>
<div className="col-sm-2">Data Attivazione</div>
<div className="col-sm-2">
  <input
    className="form-control"
    type="text"
    value={dataAttivazioneLicenza}
    id={index}
    onChange={this.changeTextDataAttivazione.bind(this)}
    disabled={true}
  ></input>
</div>
<div className="col-sm-2">Disabilita Licenza</div>
<div className="col-sm-2">
  <button
    className="btn btn-danger"
    disabled={this.state.disableInput}
    id={index}
    onClick={this.disabilitaLicenza.bind(this)}
  >
    Disabilita Licenza
  </button>
  {this.modalDisabilitaLicenzaUtente(index)}
</div> */}
          </table>
          <br></br>
          {/* <div className="col-sm-5">
<button
  className="btn btn-danger"
  disabled={this.state.disableInput}
  id={index}
  onClick={this.disabilitaLicenza.bind(this)}
>
  Disabilita Licenza
</button>
{this.modalDisabilitaLicenzaUtente(index)}
</div> */}
          <div className="row">
            {/* <div className="col-sm-2">Id Device</div>
<div className="col-sm-5">
  <input
    className="form-control"
    type="text"
    value={licenza.idDevice}
    id={index}
    onChange={this.changeTextIdDevace.bind(this)}
    disabled={this.state.disableInput}
  ></input>
</div> */}
          </div>
        </fieldset>
        <br></br>
      </fieldset>
    );
  }

  modificaUser() {
    this.setState((prevState) => ({
      disableInput: !prevState.disableInput,
    }));
    if (this.state.disableInput) {
      this.setState({ testoModifica: "Disabilita Modifiche" });
      this.setState({ enableSalvaModifice: false });
    } else {
      this.setState({ testoModifica: "Abilita Modifiche" });
      this.setState({ enableSalvaModifice: true });
    }
  }

  bottoneModificaUser() {
    return (
      <>
        <button
          type="button"
          // disabled={this.state.disableInput}
          onClick={this.modificaUser.bind(this)}
          className={
            this.state.disableInput ? "btn btn-primary" : "btn btn-secondary"
          }
          // disabled={this.state.disableInput}
        >
          {this.state.testoModifica}
        </button>
      </>
    );
  }

  showModalEliminaUser() {
    return (
      <>
        <Modal show={this.state.EliminaUserModal}>
          <Modal.Header>
          <Modal.Title>Elimina User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Eliminare l'utente {this.state.userControllore.numMatricola}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnulaEliminaUser.bind(this)}
            >
              Annulla
            </Button>
            <Button variant="danger" onClick={this.confermaElimina.bind(this)}>
              {this.state.loadingButton ? <LoadSpinner/> : "Conferma Elimina"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  modalElimina() {
    this.setState({ EliminaUserModal: true });
  }

  confermaElimina() {
    this.detailSanzioneService = new DetailUserService();
    var userControllore = JSON.parse(sessionStorage.getItem("userControllore"));

    // this.detailSanzioneService.getDetailUtente(
    //   userControllore.idAnagraficaOperatore,
    //   (result)=>{
    //     this.detailSanzioneService.deleteUser(result, (resultDelite) => {
    //       console.log(resultDelite.data)
    //       if(resultDelite.status === 200){
    //         console.log(resultDelite.data)
    //       }else{
    //         console.log("qualcosa e andaott")
    //       }
    //     })

    //   }
    // );
    // console.log(this.state.userControllore)
    this.setState({loadingButton:true})
    this.detailSanzioneService.deleteUser(
      this.state.userControllore,
      (result) => {
        this.setState({
          loadingButton:false,
          EliminaUserModal:false
        })
        // console.log(result)
        if (result.status === 200) {
          toast.success("Utente Eliminato", {
            position: toast.POSITION.TOP_RIGHT,
          });
          window.location.href = "#/manageProfile";
        } else {
          toast.error("Utente non eliminato", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }
    );

    // this.props.history.push('/manageProfile')

  }
  AnnulaEliminaUser() {
    this.setState({ EliminaUserModal: false });
  }

  bottoneEliminaUser() {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    this.ruoloLogin = decoded.RUOLO;


    return (
      <>
        {this.ruoloLogin === "4" && this.state.userControllore.numMatricola !== "" && this.state.userControllore.numMatricola !== objUser.username ? (
          <button
            type="button"
            // disabled={this.state.disableInput}
            onClick={this.modalElimina.bind(this)}
            className="btn btn-danger"
            // disabled={this.state.disableInput}
          >
            Elimina Utente
          </button>
        ) : (
          ""
        )}
      </>
    );
  }

  modalSalvaUtente() {
    this.setState({ salvaUtenteModal: true });
  }
  confermaModificaUtente() {
    // console.log("modifiche salvate");
    this.setState({loadingButton:true})
    this.detailSanzioneService.editUser(
      this.state.userControllore,
      (result) => {
        if (result.status === 200) {
          toast.success("Modifiche salvate", {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error("Modifiche non salvate", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        this.setState({
          loadingButton:false,
          salvaUtenteModal: false,
        });
      }
    );
    // console.log(this.state.userControllore);
    //this.setState({ disableInput: true });
    this.modificaUser()
    this.setState({ enableSalvaModifice: true });
  }

  AnnulaModificaUtnete() {
    this.setState({ salvaUtenteModal: false });
  }

  renderBottoneSalvaModifiche() {
    return (
      <>
        <Modal show={this.state.salvaUtenteModal}>
          <Modal.Header></Modal.Header>
          <Modal.Body>
            <Modal.Title>Conferma le modifiche utente</Modal.Title>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnulaModificaUtnete.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              onClick={this.confermaModificaUtente.bind(this)}
            >
              {this.state.loadingButton ? <LoadSpinner/> : "Conferma modifica"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  showStoricoRotolini() {
    this.setState({ showModalStoricoRotoli: true });
  }
  hiddenStoricoRotolini() {
    // console.log("Chiusura Modal");
    this.setState({ showModalStoricoRotoli: false });
  }

  renderAllStoricoRotolini() {
    return this.state.arrayListaRotoliniUtente.map((rotolini, index) => {
      const giornoCorretta =
        new Date(rotolini.dataDiEmissione).getDate() < 10
          ? "0" + new Date(rotolini.dataDiEmissione).getDate()
          : new Date(rotolini.dataDiEmissione).getDate();
      const meseCorretto =
        new Date(rotolini.dataDiEmissione).getMonth() + 1 < 10
          ? "0" + (new Date(rotolini.dataDiEmissione).getMonth() + 1)
          : new Date(rotolini.dataDiEmissione).getMonth() + 1;
      const annoCorretto = new Date(rotolini.dataDiEmissione).getFullYear();

      const ore =
        new Date(rotolini.dataDiEmissione).getHours() < 10
          ? "0" + new Date(rotolini.dataDiEmissione).getHours()
          : new Date(rotolini.dataDiEmissione).getHours();

      const minuti =
        new Date(rotolini.dataDiEmissione).getMinutes() < 10
          ? "0" + new Date(rotolini.dataDiEmissione).getMinutes()
          : new Date(rotolini.dataDiEmissione).getMinutes();

      this.dataTime =
        giornoCorretta +
        "/" +
        meseCorretto +
        "/" +
        annoCorretto +
        " " +
        ore +
        ":" +
        minuti;
      return (
        <tbody>
          <tr>
            <td>
              <p datetime={this.dataTime}>{this.dataTime}</p>
            </td>
            <td>
              <p>{rotolini.codiceRotolino}</p>
            </td>
          </tr>
        </tbody>
      );
    });
  }

  renderModalRotoliniStorico() {
    return (
      <>
        {" "}
        <Modal show={this.state.showModalStoricoRotoli}>
          <Modal.Header>
            <Modal.Title>Storico Rotolini</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{ maxHeight: "calc(100vh - 210px)", overflowY: "auto" }}
          >
            <ul className="events w-auto p-3">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Data Assegnazione</th>
                    <th scope="col">Id Rotolino</th>
                  </tr>
                </thead>

                {this.renderAllStoricoRotolini()}
              </table>
            </ul>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.hiddenStoricoRotolini.bind(this)}
            >
              Chiudi
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  showModalResetPasswordUtente() {
    this.setState({ showModalResetPasswordUtente: true });
  }

  bottoni() {
    return (
      <div className="row">
        <div className="col d-flex justify-content-center">
          <button
            type="button"
            disabled={this.state.disableInput}
            onClick={this.showModalResetPasswordUtente.bind(this)}
            className="btn btn-primary"
          >
            Reset Password
          </button>
        </div>
        <div className="col d-flex justify-content-center"></div>
        <div className="col d-flex justify-content-center">
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.modalSalvaUtente.bind(this)}
            disabled={this.state.enableSalvaModifice}
          >
            Salva Modifica
          </button>
        </div>
      </div>
    );
  }

  render() {
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        {this.anagraficaControllore()}
        {this.modalDisabilitaLicenzaUtente()}
        {this.renderBottoneSalvaModifiche()}
        {this.renderModalRotoliniStorico()}
        {this.modalResetPasswordUtente()}
        {this.showModalAssegnaRotolino()}
        {this.showModalEliminaUser()}
      </div>
    );

    return <div>{content}</div>;
  }
}

export default DetailUser;
